import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text,
  className = ''
}) => {
  const spinnerSizes = {
    sm: 'h-4 w-4 border-2',
    md: 'h-5 w-5 border-2',
    lg: 'h-6 w-6 border-[3px]'
  };

  return (
    <span
      className={`inline-flex items-center justify-center gap-2 ${className}`}
      role="status"
      aria-live="polite"
    >
      <span
        className={`${spinnerSizes[size]} animate-spin rounded-full border-current border-t-transparent`}
        aria-hidden="true"
      />
      {text ? <span>{text}</span> : <span className="sr-only">Chargement…</span>}
    </span>
  );
};

export default LoadingSpinner;
